export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-6 md:p-12 border border-background-200/70 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          {/* Left visual */}
          <div className="w-full lg:w-72 shrink-0">
            <div className="relative w-48 h-48 mx-auto bg-background-200 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20mobile%20app%20interface%20mockup%20for%20a%20Korean%20manhwa%20reading%20app%20on%20a%20phone%20screen%2C%20showing%20a%20comic%20reading%20view%20with%20scroll%20indicator%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20flat%20UI%20design%20style%2C%20clean%20and%20minimal%20layout&width=480&height=480&seq=app-mock-2026&orientation=squarish"
                alt="韩漫网APP移动端界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right text */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              APP下载
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              下载韩漫网APP，随时随地畅享海量免费韩漫。下拉式阅读、离线缓存、个性化推荐，让韩漫免费漫画阅读更加便捷流畅。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 font-medium rounded-full text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 font-medium rounded-full text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-google-play-fill text-lg"></i>
                Google Play
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}